<style scoped>
.teaxtarea-comment {
    width: 100%;
    border: 1px solid black;
    padding: 15px;
    border-radius: 15px;
    background: none;
    background-position-x: 0%;
    background-position-y: 0%;
    background-repeat: repeat;
    background-image: none;
    background-position: 4% 50%;
    background-repeat: no-repeat;
    border: 1px solid #526170;
    outline: none;
    color: white;
    text-align: left;
    font-size: 20px;
    font-family: 'AgoraSans';
}

.teaxtarea-comment:hover,
.teaxtarea-comment:focus {
    color: rgba(0, 210, 234, 1);
    border: 1px solid #00a6ec;
    -webkit-box-shadow: 0 0 15px 0 #00a6ec, inset 0px 0px 15px 0 #00a6ec;
    box-shadow: 0 0 15px 0 #00a6ec, inset 0px 0px 15px 0 #00a6ec;
    caret-color: rgb(0, 148, 223);
}

.textarea-block a.aquazor-btn {
    margin: 20px;
    display: block;
}
</style>

<template>
<div>
    <loader-component v-if="loader"></loader-component>
    <div class="textarea-block" v-if="!loader">
        <textarea class="teaxtarea-comment" rows="15" v-model="comment_text"></textarea>
        <a class="aquazor-btn" @click="saveComment">Сохранить</a>
    </div>
</div>
</template>

<script>
import config from '@/config.js'
import axios from 'axios'
import loader from './loader.vue'

export default {
    created() {
        get_comment(this)
    },
    components: {
        'loader-component': loader,
    },
    methods: {
        saveComment: function () {
            set_comment(this)
        }
    },
    data() {return {
        loader: true,
        comment_text: null
    }
    },
    props: ['id_user']
}

function get_comment(vue_obj) {
    if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('id_user', vue_obj.id_user)
        axios({
                method: 'POST',
                url: config.API_HOST + '/aquazor-users/get_comment',
                data: post_data
            })
            .then(function (response) {
                vue_obj.comment_text = response.data.comment
                vue_obj.loader = false
            })
            .catch(function (error) {

            })
    }
}

function set_comment(vue_obj) {
    if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('id_user', vue_obj.id_user)
        post_data.set('comment', vue_obj.comment_text)
        axios({
                method: 'POST',
                url: config.API_HOST + '/aquazor-users/set_comment',
                data: post_data
            })
            .then(function (response) {
                vue_obj.$emit('hideModal')
            })
            .catch(function (error) {

            })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/user-comments.vue